/**
 * Set rangy according to what we want.
 * @author Louis-Dominique Dubeau
 * @license MPL 2.0
 * @copyright Mangalam Research Center for Buddhist Languages
 */
import * as rangy from "rangy";
import "rangy-textrange";

export = rangy;
